<template>
	<p>fake email card</p>
</template>
